module.exports = __webpack_public_path__ + "img/warning-icon.78dafe48.svg";